import MedalIcon from '@synoptic/ui-kit/icons/svg/medal.svg';
import clsx from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { S3MedalsImg } from '../s3/medals/s3-img';
import { medal, medalFallback } from './medal-avatar.css';

export const MedalAvatar = function MedalAvatar({
  ref,
  s3Key,
  className,
  ...rest
}: {
  s3Key?: string;
} & Omit<ComponentPropsWithRef<'img'>, 'src'>) {
  return s3Key ? (
    <S3MedalsImg
      ref={ref}
      s3Key={s3Key}
      className={clsx(medal, className)}
      {...rest}
    />
  ) : (
    <img
      ref={ref}
      src={MedalIcon}
      className={clsx(medalFallback, className)}
      {...rest}
    />
  );
};
